function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2529 4.17128C17.2529 4.9392 16.7176 5.56171 16.0572 5.56171C15.3969 5.56171 14.8615 4.9392 14.8615 4.17128C14.8615 3.40337 15.3969 2.78086 16.0572 2.78086C16.7176 2.78086 17.2529 3.40337 17.2529 4.17128Z",
  fill: "#383A36"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0572 19.466C16.7176 19.466 17.2529 18.8435 17.2529 18.0756C17.2529 17.3076 16.7176 16.6851 16.0572 16.6851C15.3969 16.6851 14.8615 17.3076 14.8615 18.0756C14.8615 18.8435 15.3969 19.466 16.0572 19.466Z",
  fill: "#383A36"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.2744 0.5C11.2744 0.223858 11.4983 0 11.7744 0H20.3401C20.6162 0 20.8401 0.223858 20.8401 0.500001V22.2468H11.4744C11.3639 22.2468 11.2744 22.1573 11.2744 22.0468V0.5ZM12.4701 1.39043H19.6444V11.1234C19.6444 8.81969 18.0383 6.95214 16.0572 6.95214C14.0761 6.95214 12.4701 8.81969 12.4701 11.1234V1.39043ZM12.4701 11.1234V20.8564H19.6444V11.1234C19.6444 13.4272 18.0383 15.2947 16.0572 15.2947C14.0761 15.2947 12.4701 13.4272 12.4701 11.1234ZM18.4486 11.1234C18.4486 12.6592 17.378 13.9043 16.0572 13.9043C14.7365 13.9043 13.6658 12.6592 13.6658 11.1234C13.6658 9.5876 14.7365 8.34257 16.0572 8.34257C17.378 8.34257 18.4486 9.5876 18.4486 11.1234Z",
  fill: "#383A36"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.9977 23.3613L26.5531 24.7808C26.831 24.8673 27.1238 24.6992 27.1891 24.4157L31.8959 3.98898C31.9546 3.73416 31.8071 3.47713 31.5574 3.39934L23.3116 0.83009C23.0338 0.743519 22.741 0.911597 22.6757 1.19518L21.9977 4.13758V9.48856L23.6389 2.36586L30.5413 4.51654L28.3836 13.8808C28.8943 11.6643 27.7632 9.38608 25.8571 8.79218C24.3616 8.32619 22.8333 9.03564 21.9977 10.4335V15.1755C22.4626 15.9547 23.1581 16.554 24.0076 16.8187C25.9137 17.4125 27.8729 16.0972 28.3836 13.8808L26.2258 23.245L21.9977 21.9275V23.3613ZM24.3159 15.4809C25.5866 15.8768 26.8927 14.9999 27.2332 13.5223C27.5737 12.0447 26.8196 10.5259 25.5489 10.1299C24.2782 9.734 22.9721 10.6109 22.6316 12.0885C22.2911 13.5662 23.0452 15.085 24.3159 15.4809Z",
  fill: "#383A36"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1654 7.45444C26.8007 7.6524 27.4538 7.21395 27.624 6.47514C27.7943 5.73632 27.4172 4.97691 26.7819 4.77894C26.1465 4.58098 25.4935 5.01943 25.3232 5.75824C25.153 6.49706 25.53 7.25647 26.1654 7.45444Z",
  fill: "#383A36"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5415 19.8526C24.3713 20.5914 23.7182 21.0299 23.0829 20.8319C22.4475 20.6339 22.0705 19.8745 22.2407 19.1357C22.411 18.3969 23.064 17.9584 23.6994 18.1564C24.3347 18.3544 24.7118 19.1138 24.5415 19.8526Z",
  fill: "#383A36"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.68835 0.830069C8.9662 0.743498 9.25898 0.911576 9.32432 1.19516L10.0878 4.50865V9.85963L8.36108 2.36583L1.45865 4.51652L3.6164 13.8807L5.77415 23.245L10.0878 21.9009V23.3347L5.44687 24.7807C5.16903 24.8673 4.87625 24.6992 4.8109 24.4156L0.10409 3.98896C0.0453735 3.73414 0.192924 3.47711 0.442584 3.39932L8.68835 0.830069Z",
  fill: "#383A36"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.6164 13.8807C3.10568 11.6643 4.23681 9.38606 6.14286 8.79216C7.691 8.30979 9.27418 9.08694 10.0878 10.5834V15.0253C9.62489 15.8775 8.89564 16.5372 7.99236 16.8186C6.08631 17.4125 4.12713 16.0972 3.6164 13.8807ZM9.36842 12.0885C9.7089 13.5661 8.95481 15.085 7.68411 15.4809C6.41341 15.8768 5.10729 14.9999 4.76681 13.5223C4.42632 12.0447 5.18041 10.5258 6.45111 10.1299C7.72181 9.73398 9.02794 10.6109 9.36842 12.0885Z",
  fill: "#383A36"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67677 5.75822C6.84701 6.49704 6.46996 7.25645 5.83461 7.45441C5.19926 7.65238 4.5462 7.21393 4.37596 6.47512C4.20572 5.7363 4.58276 4.97689 5.21811 4.77892C5.85347 4.58096 6.50653 5.01941 6.67677 5.75822Z",
  fill: "#383A36"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M8.91711 20.8319C9.55246 20.6339 9.92951 19.8745 9.75927 19.1357C9.58902 18.3969 8.93596 17.9584 8.30061 18.1564C7.66526 18.3543 7.28822 19.1138 7.45846 19.8526C7.6287 20.5914 8.28176 21.0298 8.91711 20.8319Z",
  fill: "#383A36"
});

var SvgGlowringSavings = function SvgGlowringSavings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlowringSavings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glowring-savings.711498e9.svg";
export { ForwardRef as ReactComponent };